import React, { Component } from 'react';
import BsyDashboardMenu from "../dashboard/BsyDashboardMenu";
import BsySlidePane from "../BsySlidePane";
import BsyModulesLog from "../BsyModulesLog";
import { NavLink, withRouter } from "react-router-dom";

import './index.css'
import DocumentTitle from "react-document-title";
import { BsyUtils } from '../../utils/Utils';
import { setPageTitle } from '../../utils/setPageTitle';
import { dayjsUtils } from '../../utils/dayjsUtils';

class BsyModulesPane extends Component {
    constructor(props) {
        super(props);
        this.moduleRight = React.createRef();
        this.searchVal = React.createRef();
    }

    state = {
        menuList: [],
        list: [],
        limit: 10,
        skip: 0,
        count: 0,
        backBtn: false,
        loading: false,
        id: "",
        tip: "",
        title: "",
    }

    componentDidMount() {
        React.axios('/module/platform_type_list', {}).then((res) => {
            this.setState({
                menuList: res.data.data
            }, () => {
                this.loadList("")
                this.moduleRight.current.addEventListener('scroll', this.bindHandleScroll)
                this.searchVal.current.addEventListener("keyup", (event) => {
                    if (event.keyCode === 13) {
                        this.onSearch()
                    }
                })
            })
        }).catch(() => {
            this.setState({
                menuList: []
            })
        })
    }

    sectLoding = true;

    bindHandleScroll = (event) => {
        if (!event.srcElement.scrollTop) {
            return
        }
        const { skip, loading } = this.state



        const scrollTop =
            (event.srcElement ? event.srcElement.scrollTop : false) ||
            window.pageYOffset ||
            (event.srcElement ? event.srcElement.body.scrollTop : 0)
        // 视窗高度
        const clientHeight = (event.srcElement && event.srcElement.clientHeight) || document.body.clientHeight
        // 页面高度
        const scrollHeight = (event.srcElement && event.srcElement.scrollHeight) || document.body.scrollHeight
        // 距离页面底部的高度
        const height = scrollHeight - scrollTop - clientHeight

        if (scrollTop > 300) {
            this.setState({
                backBtn: true
            })
        } else {
            this.setState({
                backBtn: false
            })
        }

        if (height <= 10 && this.sectLoding) {
            this.sectLoding = false;
            this.setState({
                skip: skip + 1,
            }, () => {
                this.loadList()
            })
        }
    }

    loadList = () => {
        const { limit, skip, id, list } = this.state
        React.axios('/module/platform_list', {
            business: id,
            key: this.searchVal.current.value,
            limit: limit,
            skip: skip * limit,
        }).then((res) => {
            this.sectLoding = true;
            let loading = false;
            if (skip === parseInt(parseInt(res.data.count) / limit) || res.data.count <= 0) {
                loading = true;
                this.sectLoding = false;
            }
            this.setState({
                list: list.concat(res.data.data),
                count: res.data.count,
                loading: loading,
                tip: res.data.tip
            })
        })
    }

    dashboardMenuCenterMenu = () => {
        return <div className="open-header">
            <NavLink activeClassName="select" className="api-webhook" to={window.rootDirectroy + "/open/api"}>
                <div className="header-btn"><span>api</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="key-webhook" to={window.rootDirectroy + "/open/key"}>
                <div className="header-btn"><span>{React.language('key.management')}</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="form-webhook" to={window.rootDirectroy + "/open/webhook"}>
                <div className="header-btn"><span>webhook</span></div>
            </NavLink>
            <NavLink activeClassName="select" className="modules-webhook" to={window.rootDirectroy + "/open/modules"}>
                <div className="header-btn"><span>{React.language('module')}</span></div>
            </NavLink>
            {window.FX.STATIC["user_corps"]["mode"] === "common" && <NavLink activeClassName="select" className="sso-webhook" to={window.rootDirectroy + "/open/sso"}>
                <div className="header-btn"><span>{React.language('account.signin.sso')}</span></div>
            </NavLink>}
        </div>
    }
    leftTitle = () => {
        return <div className="leftTitle">
            <span>{React.language('open.platform')}</span>
        </div>
    }

    switchType = (val) => {
        return (event) => {
            event.currentTarget.parentNode.getElementsByClassName("select")[0] && event.currentTarget.parentNode.getElementsByClassName("select")[0].classList.remove("select");
            event.currentTarget.classList.add("select");
            this.setState({
                id: val.id || "",
                list: [],
                title: val.name || "",
                skip: 0,
                backBtn: false,
                loading: false
            }, () => {
                this.loadList()
            })
        }
    }

    onSearch = () => {
        this.setState({
            list: [], skip: 0
        }, () => {
            this.loadList()
        })
    }

    backTop = () => {
        this.setState({
            backBtn: false
        }, () => {
            this.moduleRight.current.scrollTop = 0
        })
    }


    openLog = (id) => {
        return () => {
            BsySlidePane({
                title: React.language('etl.log.execute'),
                hasHeader: true,
                onContentCreate: (ref) => {
                    return <BsyModulesLog alertDom={ref} id={id} />
                },
            })
        }
    }

    openMyModules = () => {
        BsyUtils.redirectTo(`/open/mymodules`, '_blank')
    }

    render() {
        const { menuList, list, tip, loading, backBtn, title } = this.state;
        setPageTitle("开放平台 - 功能插件");
        return (

            <div className="BsyModulesPane">
                <BsyDashboardMenu hasDesign={false} dashboardMenuCenterMenu={this.dashboardMenuCenterMenu} leftTitle={this.leftTitle} />
                <div className="bby-workspace-pane">
                    <div className="module-pane">
                        <div className="moduleLeft">
                            <div className="module-menu">
                                <div className="menuItem">
                                    <div className="mainNav">
                                        <div className="nav select" onClick={this.switchType("")} id="">全部</div>
                                        {
                                            menuList.map((val) => {
                                                return <div className="nav" onClick={this.switchType(val)} id={val.id}><span>{val.name}</span></div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="moduleRight" ref={this.moduleRight}>
                            <div className="moduleRightCont">
                                <div className="module-top-cont">
                                    <div className="module-top-left-cont">
                                        <div className="module-title">
                                            {!!title && <span>{title}</span>}
                                        </div>
                                        <div className="module-tip">
                                            {!!tip && <div className="mainTip">
                                                <p className="tip">
                                                    <span
                                                        title={React.language('prompt') + tip}>{React.language('prompt') + tip}</span>
                                                </p>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="module-top-right-cont">
                                        <div className="search ">
                                            <input type="text" ref={this.searchVal} placeholder={React.language('search.function.module')} />
                                            <div className="searchBtn" onClick={this.onSearch}>
                                                <i className="icon-bsy-reportmenu-0" />
                                            </div>
                                        </div>
                                        <div className="module-content-menu-btn" onClick={this.openMyModules}>
                                            <a className="btn">
                                                <i className="icon-menuIcon5" />
                                                <span>{React.language('my.module')}</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="module-content">
                                    <div className="content">
                                        <div className="ulList">
                                            <ul>
                                                {
                                                    list.map((val) => {
                                                        const releaseTime = BsyUtils.date2Str(dayjsUtils.timeToTZ(val.releaseTime), "yyyy-MM-dd HH:mm:ss");
                                                        return <li className="module-item">
                                                            <div className="item-body">
                                                                <div className="module-img">
                                                                    <img src={val.imgurl || window.rootDirectroy + "/template/formreport/static/css/resources/images/moduleExa1.png"} alt="" />
                                                                </div>
                                                                <div className="module-con">
                                                                    <div className="module-info">
                                                                        <div className="module-info-title">
                                                                            <div className="title" title={val.moduleName}>
                                                                                {
                                                                                    val.moduleName
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    {!!val.description ? <div className="module-explain"
                                                                        title={React.language('module.title4') + ": " + val.description}>
                                                                        <div className="title">{React.language('module.title4')}</div>
                                                                        <div className="text">
                                                                            {val.description}</div>
                                                                    </div> : <div className="module-explain"
                                                                        title={React.language('module.title3')}>
                                                                        <div className="title">{React.language('module.title3')}</div>
                                                                    </div>}
                                                                    <div className="module-right">
                                                                        <div className="module-version">
                                                                            <div className="module-info-description"
                                                                                title={React.language('version') + val.version}>{React.language('version') + val.version}
                                                                            </div>
                                                                        </div>
                                                                        <div className="module-time">
                                                                            <div className="module-info-description"
                                                                                title={releaseTime}>{releaseTime}
                                                                            </div>
                                                                        </div>
                                                                        <div className="module-journal">
                                                                            <div className="journal" onClick={this.openLog(val.id)}>{React.language('etl.log.execute')}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="module-test" />
                                                                </div>

                                                                <div className="module-info-classification">
                                                                    <div className="type" title={React.language('module.title1') + val.type}>{React.language('module.title1') + val.type}</div>
                                                                </div>

                                                                <div className="module-author">
                                                                    <div className="module-info-description" title={React.language('module.title2') + val.installTotal}>
                                                                        {React.language('module.title2') + val.installTotal}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    })
                                                }

                                            </ul>
                                            <div className="loading-state">{loading ? React.language('module.title5') : React.language('loading')}</div>
                                        </div>
                                    </div>
                                </div>
                                {backBtn && <div className="module-top" onClick={this.backTop}
                                    title={React.language('back.top.module')}><i className="icon-bsy-iconshang" />
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

export default BsyModulesPane;